module.exports = __webpack_public_path__ + "static/img/p4.562079a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p4.png
// module id = 65
// module chunks = 1